export default values => ({
  bankName: values?.bankName || '',
  bankCode: values?.bankCode || '',
  bankAccountNumber: values?.bankAccountNumber || '',
  bankAccountType: values?.bankAccountType || ''
});
